{
  "login": "लॉगिन",
  "logout": "लॉगआउट",
  "signOut": "साइन आउट",
  "username": "उपयोगकर्ता नाम",
  "password": "पासवर्ड",
  "forgotPassword": "पासवर्ड भूल गए?",
  "rememberMe": "मुझे याद रखें",
  "loginButton": "साइन इन करें",
  "loginError": "अमान्य उपयोगकर्ता नाम या पासवर्ड",
  "sessionExpired": "आपका सत्र समाप्त हो गया है। कृपया पुनः लॉगिन करें।",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "साइन इन हो रहा है...",
  "loginSuccess": "साइन इन सफल",
  "showPassword": "पासवर्ड दिखाएं",
  "hidePassword": "पासवर्ड छिपाएं",
  "onboardingPrompt": "अपने अस्पताल या क्लिनिक के लिए?",
  "onboardingCta": "ऑनबोर्डिंग का अनुरोध करें",
  "loginFailed": "लॉगिन विफल",
  "seatCapReached": "इस लाइसेंस के लिए उपयोगकर्ता सीमा पूरी हो गई है। अपने व्यवस्थापक से संपर्क करें।",
  "mfaCodeLabel": "सत्यापन कोड",
  "mfaCodePrompt": "साइन इन पूरा करने के लिए अपने प्रमाणक ऐप से 6-अंकीय कोड दर्ज करें।",
  "mfaSetupRequired": "आपके संगठन में बहु-कारक प्रमाणीकरण अनिवार्य है। जारी रखने के लिए अपना प्रमाणक ऐप सेट करें।",
  "mfaCodePlaceholder": "6-अंकीय कोड",
  "mfaInvalidCode": "अमान्य सत्यापन कोड",
  "pages": {
    "userProfile": {
      "title": "मेरी प्रोफ़ाइल",
      "loading": "प्रोफ़ाइल लोड हो रही है...",
      "sections": {
        "profilePicture": "प्रोफ़ाइल चित्र",
        "personalInformation": "व्यक्तिगत जानकारी",
        "changePassword": "पासवर्ड बदलें",
        "multiFactorAuth": "मल्टी-फ़ैक्टर प्रमाणीकरण"
      },
      "fields": {
        "fullName": "पूरा नाम",
        "email": "ईमेल",
        "phone": "फ़ोन",
        "currentPassword": "वर्तमान पासवर्ड",
        "newPassword": "नया पासवर्ड",
        "confirmPassword": "नए पासवर्ड की पुष्टि करें",
        "required": "*"
      },
      "actions": {
        "saveChanges": "परिवर्तन सहेजें",
        "changePassword": "पासवर्ड बदलें",
        "setUpMfa": "मल्टी-फ़ैक्टर प्रमाणीकरण सेट करें",
        "uploadAvatar": "अपलोड करें",
        "changeAvatar": "बदलें",
        "removeAvatar": "हटाएं",
        "verify": "सत्यापित करें"
      },
      "avatar": {
        "alt": "अवतार",
        "helperText": "PNG, JPEG या WebP, 4 MB तक। अपलोड से पहले {{size}}×{{size}} पर आकार बदला जाता है।"
      },
      "mfa": {
        "enabledMessage": "आपके खाते पर मल्टी-फ़ैक्टर प्रमाणीकरण सक्षम है।",
        "intro": "अपने खाते पर सुरक्षा की एक अतिरिक्त परत जोड़ने के लिए मल्टी-फ़ैक्टर प्रमाणीकरण सक्षम करें।",
        "scanInstruction": "इस URI को अपने प्रमाणक ऐप से स्कैन करें, या मैन्युअल रूप से कॉपी करें:",
        "copyUri": "URI कॉपी करें",
        "verificationCode": "सत्यापन कोड",
        "codePlaceholder": "6-अंकीय कोड दर्ज करें"
      },
      "validation": {
        "fullNameRequired": "पूरा नाम आवश्यक है",
        "emailRequired": "मान्य ईमेल आवश्यक है",
        "currentPasswordRequired": "वर्तमान पासवर्ड आवश्यक है",
        "newPasswordTooShort": "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए",
        "confirmPasswordRequired": "कृपया अपने पासवर्ड की पुष्टि करें",
        "passwordsMismatch": "पासवर्ड मेल नहीं खाते"
      },
      "toasts": {
        "profileUpdated": "प्रोफ़ाइल सफलतापूर्वक अपडेट की गई",
        "profileUpdateFailed": "प्रोफ़ाइल अपडेट करने में विफल",
        "passwordChanged": "पासवर्ड सफलतापूर्वक बदल दिया गया",
        "passwordChangeFailed": "पासवर्ड बदलने में विफल। कृपया अपना वर्तमान पासवर्ड जांचें।",
        "mfaSetupFailed": "मल्टी-फ़ैक्टर प्रमाणीकरण सेटअप शुरू करने में विफल",
        "mfaEnabled": "मल्टी-फ़ैक्टर प्रमाणीकरण सक्षम किया गया",
        "mfaInvalidCode": "अमान्य सत्यापन कोड",
        "avatarUpdated": "अवतार अपडेट किया गया",
        "avatarUpdateFailed": "अवतार अपडेट करने में विफल",
        "avatarRemoved": "अवतार हटाया गया",
        "avatarRemoveFailed": "अवतार हटाने में विफल",
        "imageTooLarge": "छवि 4 MB से कम होनी चाहिए",
        "imageTooLargeServer": "छवि बहुत बड़ी है — कृपया छोटी फ़ाइल आज़माएं",
        "copiedToClipboard": "क्लिपबोर्ड पर कॉपी किया गया"
      }
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "आपका सत्र 1 मिनट से कम में समाप्त हो जाएगा। अभी अपना कार्य सहेजें।",
      "expiringSoon_one": "आपका सत्र {{count}} मिनट में समाप्त हो जाएगा।",
      "expiringSoon_other": "आपका सत्र {{count}} मिनट में समाप्त हो जाएगा।",
      "extendButton": "सत्र बढ़ाएं"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "प्रारंभिक सेटअप",
    "subtitle": "इस इंस्टॉलेशन के लिए पहला व्यवस्थापक खाता बनाएँ।",
    "username": "उपयोगकर्ता नाम",
    "password": "पासवर्ड",
    "confirmPassword": "पासवर्ड की पुष्टि करें",
    "fullName": "पूरा नाम (वैकल्पिक)",
    "fullNamePlaceholder": "जैसे: कुमार प्रिया",
    "email": "ईमेल (वैकल्पिक)",
    "submit": "व्यवस्थापक खाता बनाएँ",
    "submitting": "खाता बनाया जा रहा है…",
    "usernameHint": "3–64 अक्षर: छोटे अक्षर, अंक, बिंदु, अंडरस्कोर और हाइफ़न।",
    "passwordHint": "कम से कम 12 अक्षर, जिसमें बड़े अक्षर, छोटे अक्षर, अंक और विशेष अक्षर हों।",
    "errUsername": "3–64 अक्षरों का उपयोग करें: a–z, 0–9, बिंदु, अंडरस्कोर या हाइफ़न।",
    "errPasswordLength": "पासवर्ड कम से कम 12 अक्षरों का होना चाहिए।",
    "errPasswordUpper": "पासवर्ड में एक बड़ा अक्षर होना चाहिए।",
    "errPasswordLower": "पासवर्ड में एक छोटा अक्षर होना चाहिए।",
    "errPasswordDigit": "पासवर्ड में एक अंक होना चाहिए।",
    "errPasswordSpecial": "पासवर्ड में एक विशेष अक्षर होना चाहिए।",
    "errConfirmRequired": "कृपया पासवर्ड की पुष्टि करें।",
    "errConfirmMismatch": "पासवर्ड मेल नहीं खा रहे हैं।",
    "errFullName": "पूरा नाम 100 अक्षरों से अधिक नहीं होना चाहिए।",
    "errEmail": "एक मान्य ईमेल पता दर्ज करें।",
    "successTitle": "व्यवस्थापक खाता बन गया",
    "successBody": "खाता “{{username}}” तैयार है। जारी रखने के लिए साइन इन करें।",
    "goToLogin": "साइन-इन पर जाएँ",
    "claimedTitle": "सेटअप पहले ही पूरा हो चुका है",
    "claimedBody": "इस सिस्टम में पहले से एक व्यवस्थापक है। अपने खाते से साइन इन करें।",
    "networkError": "सर्वर से संपर्क नहीं हो सका। अपना कनेक्शन जाँचें और पुनः प्रयास करें।",
    "retry": "पुनः प्रयास करें",
    "rateLimited": "बहुत अधिक प्रयास। एक मिनट रुककर पुनः प्रयास करें।",
    "usernameTaken": "यह उपयोगकर्ता नाम पहले से लिया जा चुका है।",
    "submitFailed": "खाता नहीं बनाया जा सका। कृपया पुनः प्रयास करें।"
  }
}
